import { useState, useEffect } from 'react';

export default function SkeletonSummary() {
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    'Analizando tu búsqueda…',
    'Buscando información relevante…',
    'Procesando resultados…',
    'Organizando contenido…',
    'Identificando las notas más relevantes…',
    'Evaluando la importancia de cada resultado…',
    'Priorizando la información más significativa…',
    'Detectando temas principales…',
    'Clasificando resultados por relevancia…',
    'Casi listo…',
    'Evaluando coincidencias…',
    'Preparando respuesta…'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <section className="skeleton-summary-card" aria-label="Resumen de resultados">
      <header className="skeleton-summary-header">
        <div className="skeleton-summary-title-wrap">
          <div className="skeleton-line summary-subtitle"></div>
        </div>
      </header>

      {[0, 1, 2].map((i) => (
        <div key={i} className="skeleton-summary-text-wrap">
          {i === 0 && <p className="skeleton-message-text">{messages[messageIndex]}</p>}
          <div className="skeleton-line skeleton-line-text"></div>
          <div className="skeleton-line skeleton-line-text"></div>
          <div className="skeleton-line skeleton-line-text skeleton-line-short"></div>
        </div>
      ))}

      <div className="skeleton-summary-footer">
        <div className="skeleton-line skeleton-action-button"></div>
      </div>
    </section>
  )
}